import { Download } from 'lucide-react';

/** The downloadable Prospect List template, served from the web app's public folder. */
export const PROSPECT_LIST_TEMPLATE_URL = '/templates/prospect-list-template.csv';

const COLUMNS: { name: string; rule: string }[] = [
  { name: 'First Name', rule: 'Required.' },
  { name: 'Last Name', rule: 'Required.' },
  { name: 'Phone', rule: 'Optional, but only people with a phone reach the call queue. 10 digits, any punctuation.' },
  { name: 'Email', rule: 'Optional. How a person on two lists is recognised as one person.' },
  { name: 'Street Address', rule: 'Optional. Helps match federal giving.' },
  { name: 'Address Line 2', rule: 'Optional. Apartment, suite or unit.' },
  { name: 'City', rule: 'Optional.' },
  { name: 'State', rule: 'Two-letter code, e.g. AL. A State or a ZIP is required.' },
  { name: 'ZIP', rule: '5 digits. A State or a ZIP is required.' },
  { name: 'Employer', rule: 'Optional. The caller sees it before dialing, and it helps match federal giving.' },
  { name: 'Occupation', rule: 'Optional. The caller sees it before dialing, and it helps match federal giving.' },
];

/**
 * The format a Prospect List upload expects: a template to download, and what each of its columns
 * holds. Column names in the template are recognised automatically; other names can be matched by hand.
 */
export function ProspectListTemplateGuide() {
  return (
    <details className="rounded-md border px-3 py-2 text-sm">
      <summary className="cursor-pointer font-medium text-foreground">What the file should look like</summary>
      <div className="mt-2 space-y-2 text-muted-foreground">
        <a
          href={PROSPECT_LIST_TEMPLATE_URL}
          download
          className="inline-flex items-center gap-1.5 font-medium text-primary underline-offset-4 hover:underline"
        >
          <Download className="h-4 w-4" />
          Download the template (CSV)
        </a>
        <p>One row per person, with these column headings. Save from Excel or Google Sheets as CSV.</p>
        <ul className="space-y-1">
          {COLUMNS.map((c) => (
            <li key={c.name}>
              <span className="font-medium text-foreground">{c.name}</span> — {c.rule}
            </li>
          ))}
        </ul>
      </div>
    </details>
  );
}
